import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mediaQueries } from '../../../../style/global-style';
import { StyledRightArrowIcon } from '../../../atoms/dreamlines-button/dreamlines-button.style';

export interface IStyledContentArticleProps {
    fullWidth: boolean;
    cropText?: boolean;
}

export const StyledContentArticle = styled.article<IStyledContentArticleProps>`
    margin-bottom: 15px;
    &:last-child {
        margin-bottom: 0;
    }
    @media ${mediaQueries.phone} {
        padding-bottom: 15px;
        border-bottom: 1px solid ${(props) => props.theme.shades.lightGrey};

        &:last-child {
            border-bottom: 0;
            padding-bottom: 0;
        }
    }

    @media ${mediaQueries.tabletAndUp} {
        margin-bottom: ${({ fullWidth }) => (fullWidth ? '35px' : '50px')};
    }
    @media ${mediaQueries.desktopAndUp} {
        margin-bottom: ${({ fullWidth }) => (fullWidth ? '35px' : '80px')};
    }
    button {
        text-align: left;
        padding: 0;
        background: none;
        border: 0;
        outline: none;
        width: 100%;
    }
    ${StyledRightArrowIcon} {
        fill: ${(props) => props.theme.colors.main4};
        right: 0;
    }
`;
export const StyledContentWrapper = styled.div`
    @media ${mediaQueries.phone} {
        display: flex;
    }
    /* temporary fix to show image of different aspect ratio on mobile untill we get diffferent thumbnail image for mobile */

    @media ${mediaQueries.tabletAndUp} {
        margin-bottom: 20px;
    }

    &:after {
        content: '';
        clear: both;
        display: table;
    }
`;
export const StyledDescription = styled.div<IStyledContentArticleProps>`
    ${({ cropText }) =>
        cropText &&
        css`
            @media ${mediaQueries.phone} {
                /**
            Css based ellipsis, crops the text when the viewport is small without needing
            user-agent based detection.
            Supported by > 95% of mobile users https://caniuse.com/#feat=css-line-clamp
            */
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                display: -webkit-box;

                width: 90%;
            }
        `};
`;
export const StyledContent = styled.div<IStyledContentArticleProps>`
    position: relative;
    width: 100%;
    @media ${mediaQueries.phone} {
        padding-left: ${({ fullWidth }) => (fullWidth ? '0' : '15px')};
        width: ${({ fullWidth }) => (fullWidth ? 'auto' : 'calc(100% - 130px)')};
    }
    ${StyledRightArrowIcon} {
        display: none;
        @media ${mediaQueries.phone} {
            display: block;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    h4 {
        margin: 0 0 10px;
        padding-right: 20px;
        font-size: ${(props) => props.theme.fontSize.copyTextL};
        font-weight: bold;
        word-break: break-word;
        color: ${(props) => props.theme.shades.blackGrey};
        line-height: 1.5;

        @media ${mediaQueries.tabletAndUp} {
            font-size: ${(props) => props.theme.fontSize.headlineXS};
        }
    }
    p,
    li {
        padding: 0;
        margin: 0;
        font-size: ${(props) => props.theme.fontSize.copyTextL};
        color: ${(props) => props.theme.shades.blackGrey};
        line-height: 21px;
        @media ${mediaQueries.tabletAndUp} {
            font-size: ${(props) => props.theme.fontSize.copyTextM};
        }
    }
    ul {
        padding-left: 20px;
        overflow: auto;
    }
    @media ${mediaQueries.desktopAndUp} {
        padding-right: 20px;
    }
`;

export const StyledContentImage = styled.div<IStyledContentArticleProps>`
    @media ${mediaQueries.phone} {
        width: ${({ fullWidth }) => (fullWidth ? 'auto' : '130px')};
    }
    /* temporary fix to show image of different aspect ratio on mobile untill we get diffferent thumbnail image for mobile */
    img {
        height: 145px;
        object-fit: cover;
        @media ${mediaQueries.tabletAndUp} {
            width: 100%;
            height: auto;
            object-fit: initial;
        }
    }
`;

export const StyledContentLinksWrapper = styled.div<{ alignLinksCenter: boolean }>`
    display: none;

    & > a {
        font-size: ${(props) => props.theme.fontSize.copyTextM};
        font-weight: 600;
        color: ${(props) => props.theme.colors.main4};
        text-decoration: none;
        position: relative;
        display: inline-block;
        margin-bottom: 15px;
        ${StyledRightArrowIcon} {
            width: 9px;
            height: 10px;
            margin-left: 5px;
            right: auto;
            position: relative;
        }
        @media ${mediaQueries.tabletAndUp} {
            width: 50%;
        }
        @media ${mediaQueries.desktopAndUp} {
            width: 25%;
        }
    }
    @media ${mediaQueries.tabletAndUp} {
        display: flex;
        flex-wrap: wrap;
    }

    @media ${mediaQueries.desktopAndUp} {
        justify-content: flex-start;
        text-align: center;
        ${(props) => {
            return (
                props.alignLinksCenter &&
                css`
                    justify-content: center;
                `
            );
        }}
    }
`;

// design the appearance of copy content module inside modal
export const StyledContentItemOverlayWrapper = styled.div`
    max-height: 100vh;
    overflow: auto;
    padding-bottom: 40px;
    ${StyledContentWrapper} {
        display: block;
        img {
            width: 100%;
            height: auto;
            object-fit: initial;
        }
    }
    ${StyledContentImage} {
        width: 100%;
    }
    ${StyledContentLinksWrapper} {
        display: block;
        padding: 0 15px 50px;
        a {
            display: block;
            svg {
                top: 2px;
            }
        }
    }
    h3 {
        /* custom fontsize , so not using dynamic variable */
        font-size: 22px;
        font-weight: 600;
    }

    ${StyledContent} {
        margin: 10px 0 30px 0;
        padding: 0 15px;
        width: 100%;
        ${StyledRightArrowIcon} {
            display: none;
        }
    }
    ${StyledDescription} {
        width: auto;
    }
`;
